<template>
  <section v-if="!appConfig.capacitorApp && !desktopInstall.installed" class="desktop-install">
    <nav class="conversation-tool-list desktop-install-action">
      <button type="button" :disabled="desktopInstall.busy" @click="install"><span aria-hidden="true">▣</span><strong>{{ language.t('install.add') }}</strong><small>›</small></button>
    </nav>
    <div v-if="notice" class="desktop-install-notice" role="status">
      <p>{{ language.t(`install.${notice}`) }}</p>
      <button type="button" class="ghost-inline-action" @click="notice = ''">{{ language.t('common.close') }}</button>
    </div>
  </section>
</template>
<script setup>
import { ref } from 'vue';
import { appConfig } from '@/config';
import { useLanguageStore } from '@/stores/language';
import { desktopInstall, requestDesktopInstall } from '@/services/desktopInstall';
const language = useLanguageStore();
const notice = ref('');
async function install() { notice.value = await requestDesktopInstall(); }
</script>
<style scoped>
.desktop-install-notice { margin: 8px 0 12px; padding: 12px; border: 1px solid var(--border-color, #ccd7df); border-radius: 8px; overflow-wrap: anywhere; }
.desktop-install-notice p { margin: 0 0 8px; line-height: 1.6; }
.desktop-install-action { padding: 0; border: 1px solid #8ccac1; border-radius: 10px; background: #e5f5f1; }
.desktop-install-action button { min-height: 58px; grid-template-columns: 30px minmax(0, 1fr) auto; border-radius: 9px; color: #124f4a; font-size: 15px; }
.desktop-install-action button:hover { background: #d5eee8; }
.desktop-install-action button > span { color: #08796e; }
.desktop-install-action button > small { color: #39776f; }
.desktop-install-action button:disabled { opacity: .65; cursor: wait; }
.desktop-install-notice { margin-top: 8px; background: var(--panel, #fff); }
</style>
